<template>
    <box-model title="今日农产品涨幅排名">
      <template v-slot:content>
        <div v-if="!show" class="no-data-sty" style="height: 292px;">暂无数据</div>
        <div v-else>
          <div class="title">
            <div class="tag-part flex-y-center">
              <div class="t mgn-right-8"></div>
              <span class="mgn-right-16">涨幅</span>
              <div class="t1 mgn-right-8"></div>
              <span>跌幅</span>
            </div>
            <div class="unit">单位：{{ unit }}</div>
          </div>
          <div id="bar" class="con"></div>
        </div>
      </template>
    </box-model>
</template>
<script>
  import echarts from 'echarts';
  import { getIncreaseRanking } from "@/api/index";
  export default {
    data() {
      return {
        option: {},
        unit: '%',
        show: false
      }
    },  
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted() {
      this.getIncreaseRankingEvent();
    },
    methods: {
      init(option){
        const myChart = echarts.init(document.getElementById('bar'));
        myChart.setOption(option);
      },
      getIncreaseRankingEvent() {
        getIncreaseRanking().then((res) => {
          if(!res.data){
            this.show = false;
            return;
          };
          const result = JSON.parse(res.data);
          this.show = true;
          this.$nextTick(() => {
            this.unit = result.unit || '%';
            this.init(this.setOptions(result));
            this.setFontSizeItem(result.priceHbs);
          });
        })
      },
      setOptions(result) {
        const that = this;
        return {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function(e) {
              let item = e[0];
              let result = `
                <div style="padding: 12px;">
                  <div style="color: #3E3E3E;font-size: 15px;">${item.name}</div>
                  <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                  <div style="display: flex;align-items: center;">
                    <div style="width: 8px;height: 8px;background: ${+item.value > 0 ? 'linear-gradient(180deg, #FF6637 1%, #F4A260 99%);' : 'linear-gradient(180deg, #0580B7 0%, #06F7A1 100%);'};border-radius: 50%;"></div>
                    <div style="color: #000E2B;font-size: 15px;margin-left: 4px;line-height: 16px;">${ +item.value > 0 ? '涨幅' : '跌幅' }：${item.value}%</div>  
                  </div>
                </div>
              `;
              return result;
            },
            backgroundColor: '#fff'
          },
          grid: {
            left: '0%',
            top:'15px',
            right: '0%',
            bottom: '10%',
            containLabel: true
          },
          dataZoom: [
            {
              type: "slider",
              realtime: true,
              startValue: 0,
              endValue: 5,
              height: 4,
              handleSize: 0,            // 两边手柄尺寸
              showDetail: false,        // 拖拽时是否展示滚动条两侧的文字
              top: "95%",
              borderColor: "transparent",
              borderRadius: {topLeft: '10%', topRight: '10%', bottomLeft: '10%', bottomRight: '10%'}
            },
            {
              type: "inside",           // 支持内部鼠标滚动平移
              startValue: 0,
              endValue: 5,
              zoomOnMouseWheel: false,  // 关闭滚轮缩放
              moveOnMouseWheel: true,   // 开启滚轮平移
              moveOnMouseMove: true,    // 鼠标移动能触发数据窗口平移
            },
          ],
          xAxis: {
            data: result.names,
            axisLine: {
              show:false
            },
            axisLabel: {
              show: true,
              color: '#fff',
              interval: 0
            }
          },
          yAxis: {
            name: "",
            nameTextStyle: {
              color: '#fff',
              fontSize: 14
            },
            axisLine: { show:false, },
            axisLabel: {
              color: '#fff',
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)',
                type: 'dotted',
              }
            },
            interval:2
          },
          series: [{
            type: 'bar',
            barWidth: '30%',
            itemStyle: {
              normal: {
                color: function(params) {
                  let v = +params.value;
                  if(v > 0){
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#FF6637'
                    }, {
                      offset: 1,
                      color: '#F4A260'
                    }], false)
                  } else {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#0580B7'
                    }, {
                      offset: 1,
                      color: '#06F7A1'
                    }], false)
                  }
                }
              }
            },
            // label: {
            //   show: true,
            //   position: 'top',
            //   textStyle: { 
            //     fontSize: '12px',
            //     color: '#fff'
            //   },
            //   formatter: '{@score}'
            // },
            data: result.priceHbs
          }],
        }
      },
      setFontSizeItem(arr){
        let result = [];
        arr.forEach((item) => {
          if(+item > 0){
            result.push({
              value: +item, 
              itemStyle: {
                normal: {
                  label: {
                    position: 'top',
                    color: '#FF6637'
                  }
                }
              }
            })
          } else {
            result.push({
              value: +item,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: 'bottom',
                    color: '#06F7A1'
                  }
                }
              }
            })
          }
        })
        return result;
      }
    }
  }
</script>
<style scoped lang="less">
  .title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 12px;
    margin-bottom: 20px;
    .tag-part {
      height: 14px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255,255,255,0.6);
      .t {
        width: 8px;
        height: 8px;
        background: linear-gradient(180deg, #FF6637 1%, #F4A260 99%);
      }
      .t1 {
        width: 8px;
        height: 8px;
        background: linear-gradient(180deg, #0580B7 0%, #06F7A1 100%);
      }
      .mgn-right-8 {
        margin-right: 8px;
      }
      .mgn-right-16 {
        margin-right: 16px;
      }
    }
    .unit {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255,255,255,0.6);
      line-height: 14px;
    }
  }
  .con {
    width: 100%;
    height: 260px;
  }
</style>
